// import Vue from 'vue'
// import vSelect from 'vue-select'
// Vue.component('v-select', vSelect)


//////////////////
// WEBPACK FOOTER
// ./plugins/vselect.js
// module id = ./plugins/vselect.js
// module chunks = 82